var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"openfield",style:(_vm.isPoint()),attrs:{"src":_vm.body,"id":"iid"}})
}
var staticRenderFns = []

export { render, staticRenderFns }